// extracted by mini-css-extract-plugin
module.exports = {"area_list":"area_list-2p4WRLj9"};